
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';
import { HistoryList } from '@husky-x/history-list';
import { HistoryMock, HistoryMockFr } from './custom-components-mocks';
import React from 'react'

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'HistoryCustomComponent',
        component: () => <HistoryList {...HistoryMock} />,
      },
      {
        key: 'HistoryCustomComponentFr',
        component: () => <HistoryList {...HistoryMockFr} />,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
